import { Button } from "@backslashbuild/pp-ui";
import React from "react";

export default function LockButton({ onClick }) {
  return (
    <Button
      large
      onClick={() => {
        onClick();
      }}
    >
      Lock
    </Button>
  );
}
